import { GET_USER_FROM_SESSION } from '../Types';

/**
 * Get a user from the session
 *
 * @param {}
 */
export const getUserFromSession = () => {
  return (dispatch) => {
    const action = {
      type: GET_USER_FROM_SESSION,
      request: async (apiClient) => {
        const user = await apiClient.token.getUser();

        return user;
      },
    };

    dispatch(action);
  };
};

export default getUserFromSession;
